export default function (context) {
  if (process.client) {
    const { store, from } = context
    store.commit("routing/SET_PREVIOUS", from.path)
  } else {
    const { store, route } = context
    store.commit("routing/SET_PREVIOUS", route.path)
  }
}
